import { useConfigStore } from '#ui-shared/stores/config-store';

export function bootstrapConfig(serverUrl?: string | null): void {
  const configStore = useConfigStore();

  if (serverUrl) {
    configStore.setBaseUrl(serverUrl);
  }
  else if (import.meta.env.VITE_FRONTEND_NORA_API_URL) {
    configStore.setBaseUrl(import.meta.env.VITE_FRONTEND_NORA_API_URL);
  }
  else {
    const url = new URL(window.location.origin);

    const baseUrl = `${url.protocol}//${url.host}${url.pathname}`.replace(
      /\/$/,
      '',
    );

    configStore.setBaseUrl(baseUrl);
  }
}
